<script>
  export let playing = false
  import {
    createEventDispatcher
  } from 'svelte';

  const dispatch = createEventDispatcher();
</script>

<button on:click="{() => dispatch('pressed', {playing})}" type="button" aria-label="Play">
  {#if !playing}
  <svg class="play" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <g id="play_arrow_24px">
      <path id="icon/av/play_arrow_24px" d="M6.5 5V19L17.5 12L6.5 5Z" fill="#202020" />
    </g>
  </svg>
  {:else}
  <svg class="pause" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <g id="pause_24px">
      <path id="icon/av/pause_24px" fill-rule="evenodd" clip-rule="evenodd" d="M10 19H6V5H10V19ZM14 19V5H18V19H14Z" fill="#333333" />
    </g>
  </svg>
  {/if}
</button>

<style>
  button {
    position: relative;
    top: 0;
    left: 0;
    padding: 16px 20px;
    background: #FDFFFC;
    border: 2px solid #202020;
    box-shadow: 4px 4px 0px #FF9F1C;
    border-radius: 28px;
    transition: 0.1s;
    outline: none;
    max-width: 56px;
    max-height: 56px;
  }

  button:hover,
  button:focus {
    top: 2px;
    left: 2px;
    box-shadow: 2px 2px 0px #FF9F1C;
  }

  button:active {
    top: 4px;
    left: 4px;
    box-shadow: 0px 0px 0px;
  }

  .play {
    position: relative;
    top: -3px;
    left: -4px;
  }

  .pause {
    position: relative;
    top: -2px;
    left: -6px;
  }
</style>
